import { SimpleDialogData } from "../../ui/dialog/simple-dialog/simple-dialog.model";

export const defaultWelcomeTitle: string = "Welcome back!";
export const defaultWelcomeDescription: string = "We're delighted <br />to see you again";

export function getForgotPasswordClosedDialogData(email: string, noReplyEmail: string): SimpleDialogData {
  return {
    body:
      `We sent an email to ${email} with instructions on how to reset your password.<br /><br />
      If you can't find the email in your inbox, check your spam folder. The email should come from: ${noReplyEmail}`,
    title: "Forgot your password?"
  }
}
